module.exports = __webpack_public_path__ + "static/media/Russian_Tatyana BG-09.2bfdbc05.png";